export const wsBackendBaseUrl = 'wss://gamebackend.buddhabrothers.io/ws/';

export const backendBaseUrl = 'https://gamebackend.buddhabrothers.io/';
export const authBackendBaseUrl = backendBaseUrl + 'auth/';

export const ROUND_SECONDS = 60;
export const STAY_LEAVE_DECISION_SECONDS = 15;

export const CONDITION_TO_PLAY = true;
